import { useMemo, useState } from "react";

// Paginación de listas — regla de diseño (2026-09-30): 30 filas por página +
// navegación Anterior/Siguiente por defecto (no "cargar más"/scroll infinito).
// Ver memoria feedback-usabilidad-listas.
//
// Uso (cliente, cuando la lista completa ya está en memoria):
//   const pag = usePaginacion(filtrados);         // 30 por página
//   ...{pag.slice.map(x => ...)}...
//   <Paginacion pag={pag} />
//
// `slice` es la porción visible; `pagina` viene ya acotada al rango válido,
// así que si un filtro reduce la lista no hace falta resetear a mano.
export const PAGE_SIZE_DEFECTO = 30;

export function usePaginacion(items, pageSize = PAGE_SIZE_DEFECTO) {
  const arr = Array.isArray(items) ? items : [];
  const [pagina, setPagina] = useState(1);
  const totalPags = Math.max(1, Math.ceil(arr.length / pageSize));
  const actual = Math.min(Math.max(1, pagina), totalPags);
  const slice = useMemo(
    () => arr.slice((actual - 1) * pageSize, actual * pageSize),
    [arr, actual, pageSize],
  );
  return { pagina: actual, setPagina, totalPags, slice, total: arr.length, pageSize };
}

export default function Paginacion({ pag, className = "" }) {
  const { pagina, setPagina, totalPags, total, pageSize } = pag;
  if (total <= pageSize) return null;
  return (
    <div className={`mt-3 flex items-center justify-between text-xs text-slate-500 ${className}`}>
      <span>{(pagina - 1) * pageSize + 1}–{Math.min(pagina * pageSize, total)} de {total}</span>
      <div className="flex items-center gap-1">
        <button type="button" className="btn-ghost px-2 py-1 disabled:opacity-40"
          disabled={pagina <= 1} onClick={() => setPagina(pagina - 1)}>Anterior</button>
        <span className="px-1">Página {pagina} / {totalPags}</span>
        <button type="button" className="btn-ghost px-2 py-1 disabled:opacity-40"
          disabled={pagina >= totalPags} onClick={() => setPagina(pagina + 1)}>Siguiente</button>
      </div>
    </div>
  );
}
